import { animate, style, transition } from '@angular/animations';

export const settingsMainPage = [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(-20px) translateZ(0)' }),
    animate('0.4s cubic-bezier(0.25, 1, 0.5, 1)', style({ opacity: 1, transform: 'translateX(0px) translateZ(0)' })),
  ]),
];

export const settingsSubPage = [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(20px) translateZ(0)' }),
    animate('0.4s cubic-bezier(0.25, 1, 0.5, 1)', style({ opacity: 1, transform: 'translateX(0px) translateZ(0)' })),
  ]),
];
